import type { CircleAnnotation, MarkShape } from "@/types/annotation";

export const markShapeOf = (annotation: CircleAnnotation): MarkShape =>
  annotation.shape ?? "circle";

// An X's arms end on the ring a circle of the same size would draw.
const X_ARM_RATIO = Math.SQRT1_2;
// A dot fills half the radius, so a large size doesn't hide the skin under it.
const DOT_RADIUS_RATIO = 0.5;

/** The two strokes of an X centred on (cx, cy), as [x1, y1, x2, y2] pairs. */
export const xMarkSegments = (
  cx: number,
  cy: number,
  radius: number,
): [number, number, number, number][] => {
  const d = radius * X_ARM_RATIO;
  return [
    [cx - d, cy - d, cx + d, cy + d],
    [cx - d, cy + d, cx + d, cy - d],
  ];
};

export const dotMarkRadius = (radius: number): number =>
  radius * DOT_RADIUS_RATIO;

/** Draws a circle-tool mark on a canvas with the context's current stroke and fill. */
export const drawMarkShape = (
  ctx: CanvasRenderingContext2D,
  shape: MarkShape,
  cx: number,
  cy: number,
  radius: number,
) => {
  ctx.beginPath();
  if (shape === "dot") {
    ctx.arc(cx, cy, dotMarkRadius(radius), 0, Math.PI * 2);
    ctx.fill();
    return;
  }
  if (shape === "x") {
    for (const [x1, y1, x2, y2] of xMarkSegments(cx, cy, radius)) {
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
    }
  } else {
    ctx.arc(cx, cy, radius, 0, Math.PI * 2);
  }
  ctx.stroke();
};
